import ApiService from '@/services/core/api.service'

const LiveStockCategoryService = {
  async get (query) {
    return ApiService.get(`admin/live-stock-categories?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/live-stock-categories', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/live-stock-categories/${payload.id}`, payload)
  }
}

export default LiveStockCategoryService
